import Rellax from 'rellax'

class Parallax
{
    constructor( options )
    {
        this.rellax
    }

    init() {
        this.rellax = new Rellax('.rellax');
    }
}
export default Parallax